import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { RecordVideoModal } from './RecordVideoModal';

const RecordVideoModalBridge = react2angular(RecordVideoModal, []);

export default RecordVideoModalBridge;
